import * as types from '../../actions/types';

export default (state = { isOpen: false, step: 'search' }, action) => {
  switch(action.type) {
    case types.OPEN_SEARCH:
      return { ...state, isOpen: true, step: 'search' };
    case types.CLOSE_SEARCH:
    	return { ...state, isOpen: false };
    case types.SET_SEARCH_STEP:
    	return { ...state, step: action.step };
    default:
      return state;
  }
};




// WEBPACK FOOTER //
// ./src/store/reducers/search.js